
import _ from 'lodash';
import cx from 'classnames';

import styles from './palette.module.scss';
import { ASSET } from 'constants/widgetTypes';
import { PAGE } from 'constants/widgetDisplayTypes';
import { DOCUMENT, VIDEO, AUDIO } from 'constants/widgetAssetTypes';

export const generateAssetWidgetData = (assetType) => {

  switch (assetType) {
    case DOCUMENT:
      return {
        type: ASSET,
        name: "Inline Asset",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "50%, 0px",
                "rotate": "0deg"
              },
              "width": "1200px",
              "height": "400px"
            },
            "type": assetType,
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 242,
                "g": 242,
                "b": 242,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "display": PAGE,
            "fullHeight": false,
            "video": null
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "auto"
            },
            "type": null,
            "background": null,
            "display": null,
            "fullHeight": false,
            "video": null
          }
        },
        content: null
      }
    case 'VIDEO':
      return {
        type: ASSET,
        name: "Inline Asset",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": `50%, 0px`,
                "rotate": "0deg"
              },
              "width": null,
              "height": "400px"
            },
            "type": assetType,
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "display": PAGE,
            "fullHeight": false,
            "video": null
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "200px"
            },
            "type": null,
            "background": null,
            "display": null,
            "fullHeight": false,
            "video": null
          }
        },
        content: null
      }
    case 'AUDIO':
      return {
        type: ASSET,
        name: "Inline Asset",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": `50%, 0px`,
                "rotate": "0deg"
              },
              "width": null,
              "height": "400px"
            },
            "type": assetType,
            "background": {
              "type": "color",
              "color": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "media": null,
              "opacity": 0,
              "scale": null,
              "position": null
            },
            "display": PAGE,
            "fullHeight": false,
            "video": null
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "auto"
            },
            "type": null,
            "background": null,
            "display": null,
            "fullHeight": false,
            "video": null
          }
        },
        content: null
      }
    default:
      break;
  }
}

export const inlineAssetCards = [
  {
    id: 'pdf_asset',
    name: 'Document (PDF,PPT, or DOC)',
    render: () => {
      return <img className={cx(styles.inlineassetCard)} src="/images/inlineassets/doc.png" />
    },
    data: generateAssetWidgetData(DOCUMENT)
  },
  {
    id: 'video_asset',
    name: 'Video',
    render: () => {
      return <img className={cx(styles.inlineassetCard)} src="/images/inlineassets/video.png" />
    },
    data: generateAssetWidgetData(VIDEO)
  }
]